import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-session-expired-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './session-expired-dialog.component.html',
})
export class SessionExpiredDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

}